/*
 * fn: isValidEmail
 *
 * Determines if an input is a valid email
 *
 */
const EMAIL_REGEX =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

export const isValidEmail = (input: string) => EMAIL_REGEX.test(input.trim())
